export const makeAbstractMethod = (name: string) => ((..._args: Array<any>) => { throw new Error(`${name} not implemented`)});